// Aggressive cache busting component
// This component runs on every page load to ensure users get the latest version
// Silent operation - no notifications or periodic checks

import { useEffect } from 'react';

const CacheBuster = () => {
  useEffect(() => {
    // Clear all caches on every page load (aggressive approach)
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }

    // Unregister service workers
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.unregister();
        });
      });
    }

    // Clear IndexedDB (if used)
    if ('indexedDB' in window && indexedDB.databases) {
      indexedDB.databases().then(databases => {
        databases.forEach(db => {
          if (db.name) {
            indexedDB.deleteDatabase(db.name);
          }
        });
      });
    }
  }, []);

  return null; // This component doesn't render anything
};

export default CacheBuster;
